import { TextInput } from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const accountPayableCardFilterList = [
  <MuiDatePickerInput
    alwaysOn
    source="start_date"
    variant="outlined"
    label="mine.label.start_date"
    maxDateSource="end_date"
  />,
  <MuiDatePickerInput
    alwaysOn
    source="end_date"
    variant="outlined"
    label="mine.label.end_date"
    minDateSource="start_date"
  />,
  <TextInput
    alwaysOn
    resettable
    source="code"
    variant="outlined"
    label="mine.label.code"
  />,
  <TextInput
    alwaysOn
    resettable
    source="name"
    variant="outlined"
    label="mine.label.name"
  />,
];

export default accountPayableCardFilterList;
